// Resume Last Work Experience ***************************************************************************
// pathname: /v1/resume/last-work-experience
// ************************************************************************************************
import { ApiLastWorkExperienceOk, useSwrApi } from '@hooks/useSwrApi';

interface SwrResumeLastWorkExperienceProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch last work experience data.
 * @param props - { SwrResumeLastWorkExperienceProps } - the props object.
 * @param props.locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param props.shouldFetch - { boolean } - a flag indicating whether to start fetching. Default: true
 */

export const useSwrResumeLastWorkExperience = (props: SwrResumeLastWorkExperienceProps) => {
  // Destructure props
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiLastWorkExperienceOk>({
    url: '/v1/resume/last-work-experience',
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 60 * 1000, // 1 minute
      revalidateOnFocus: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
